<template>
  <div>
    <b-modal ref="modalUsuarios" scrollable hide-footer size="lg" centered :title="'Grupo: ' + nombreGrupo">
      <div>
        <b-table :items="items" head-variant="light" :fields="fields">
          <template #cell(dispositivos)="data">
            <div class="chips">
              <b-badge v-for="(dispositivo, i) in toArray(data.item.dispositivos)" :key="i" pill class="chip"
                variant="primary">
                {{ dispositivo }}
              </b-badge>
              <span v-if="!toArray(data.item.dispositivos).length" class="text-muted">
                Sin dispositivos
              </span>
            </div>
          </template>

          <template #cell(usuariosAdministradores)="data">
            <div class="chips">
              <b-badge v-for="(userAdmin, i) in toArray(data.item.usuariosAdministradores)" :key="i" pill class="chip"
                variant="success">
                {{ userAdmin }}
              </b-badge>
              <span v-if="!toArray(data.item.usuariosAdministradores).length" class="text-muted">
                Sin usuarios administradores
              </span>
            </div>
          </template>

          <template #cell(usuariosFinales)="data">
            <div class="chips">
              <b-badge v-for="(userFinal, i) in toArray(data.item.usuariosFinales)" :key="i" pill class="chip"
                variant="info">
                {{ userFinal }}
              </b-badge>
              <span v-if="!toArray(data.item.usuariosFinales).length" class="text-muted">
                Sin usuarios finales
              </span>
            </div>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    datosGrupo: {
      type: Object,
      default: () => ({}),
    },
    nombreGrupo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fields: ["dispositivos", "usuariosAdministradores", "usuariosFinales"],
    };
  },
  computed: {
    items() {
      if (!this.datosGrupo || Object.keys(this.datosGrupo).length === 0) {
        return [];
      }
      return [
        {
          dispositivos:
            this.datosGrupo.dispositivos?.join(", ") || "Sin dispositivos",
          usuariosAdministradores:
            this.datosGrupo.usuariosAdminiatradores?.join(", ") ||
            "Sin usuarios administradores",
          usuariosFinales:
            this.datosGrupo.usuariosFinales?.join(", ") ||
            "Sin usuarios finales",
        },
      ];
    },
  },
  methods: {
    showModal() {
      this.$refs.modalUsuarios.show();
    },

    toArray(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      return value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    },
  },
};
</script>

<style scoped>
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0.3rem;
}

.chip {
  font-size: 0.85rem;
  font-weight: 500;
  background-color: #f1f3f5 !important;
  color: #2c3e50 !important;
  border-radius: 8px;
  padding: 0.35rem 0.75rem;
  border: 1px solid #dcdcdc;
  transition: all 0.2s ease-in-out;
}

.chip:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #e9ecef !important;
}

/* Mejoras visuales para móvil */
@media (max-width: 600px) {
  .chip {
    font-size: 0.75rem;
    padding: 0.25rem 0.6rem;
  }

  .chips {
    gap: 0.3rem;
  }
}

@media (min-width: 2500px) {
  .modal-lg,
  .modal-xl {
    max-width: 1600px !important;
  }

  /* Control de modales */
  ::v-deep .modal-ultrawide-custom,
  ::v-deep .modal-pegsa-ultrawide {
    max-width: 1600px !important;
    /* Límite para evitar fatiga visual */
    margin-left: auto;
    margin-right: auto;
  }

  /* Espaciado interno del contenido */
  .px-ultrawide {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  /* Escalado de fuentes y controles */
  .custom-table-pegsa {
    font-size: 1.3rem !important;
    /* Texto más grande para lectura a distancia */
  }

  .custom-input-height {
    height: 70px;
    font-size: 1.4rem;
  }

  .chip {
    font-size: 1.1rem;
    padding: 0.6rem 1.2rem;
    gap: 0.8rem;
  }

  .chips {
    gap: 0.8rem;
  }
}


::v-deep .modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}
</style>
